


























import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import Card from '@/components/Card.vue'
import Alert from './Alert.vue'
import AlertSettingsModal from './AlertSettingsModal.vue'
import { UserModule } from '@/store/modules/user.module'
import AllAlerts from './AllAlerts.vue'
import { NoCache } from '@/decorators/NoCache'
import { EAlertStatus, IAlert } from '@zunta/configurations'

@Component({
  props: {

  },
  components: {
    Icon,
    Card,
    Alert,
    AlertSettingsModal,
    AllAlerts
  }
})
export default class AlertsDetails extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  showSettings: boolean = false;
  showAllAlerts: boolean = false;
  pageSize: number = 0
  alertIndex: number = 0
  get alerts () {
    return this.$store.state.user.alerts
  }

  get filteredAlerts () {
    return this.alerts.filter((alert: IAlert) => [EAlertStatus.NEW, EAlertStatus.POSTPONED].includes(alert.status))
  }
  @NoCache
  get displayAlerts () {
    return this.filteredAlerts.slice(this.alertIndex, this.alertIndex + this.pageSize)
  }

  calculatePageSize () {
    if (this.$refs.alertsPanel) {
      const rect = (this.$refs.alertsPanel as Element).getBoundingClientRect()
      this.pageSize = Math.floor(rect.width / 375)
    } else {
      this.pageSize = 0
    }
  }

  mounted () {
    this.calculatePageSize = this.calculatePageSize.bind(this)
    this.calculatePageSize()
    window.addEventListener('resize', this.calculatePageSize)
    window.addEventListener('zoom', this.calculatePageSize)
  }

  isPrevAvailable () {
    return this.alertIndex > 0
  }

  isNextAvailable () {
    return this.alertIndex < this.filteredAlerts.length - 1
  }

  goPrev () {
    this.alertIndex = Math.max(this.alertIndex - this.pageSize, 0)
  }

  goNext () {
    this.alertIndex = Math.min(this.filteredAlerts.length - 1, this.alertIndex + this.pageSize)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.calculatePageSize)
    window.removeEventListener('zoom', this.calculatePageSize)
  }
}
